//common
import { Status, WorkState, MonitorInterTypeEnum } from "../enum/generalEnum";
import { EnergyTypeEnumBase } from "../enum/energyTypeCommonEnum";
import store from "@/store/store.js";
import dateTimeUtils from './dateTimeUtils'

import moment from "moment";
//设定moment区域为中国
import "moment/locale/zh-cn";
// import { indexOf } from "../../config/getIp";
moment.locale("zh-cn");
moment.suppressDeprecationWarnings = true; //禁用弃用警告

export default class GlobalUtil {
    static status = Status;
    static energyType = EnergyTypeEnumBase;
    static monitorInterfaceType = MonitorInterTypeEnum;

    constructor() { }
    /**
     * 获取当前日期前n个月
     * @returns {Date}
     */
    static getBeforeMonth(val) {
        let res = moment().subtract(val, "M").format("YYYY-MM");
        console.log("getBeforeMonth :>> ", res);
        return res;
    }
    /*---------------------------------start----------------------------------*/
    //获取查询的开始时间
    static getSearchStartTime(res, hms) {
        var startDateValue = "";
        var suffix = hms ? " 00:00:00" : "";
        if (!res.startDateValue) {
            startDateValue = "";
        } else if (res.startDateValue.length == 4) {
            startDateValue = res.startDateValue + "-01-01" + suffix;
        } else if (res.startDateValue.length < 8) {
            startDateValue = res.startDateValue + "-01" + suffix;
        } else if (res.startDateValue.length < 12) {
            startDateValue = res.startDateValue + suffix;
        } else {
            startDateValue = res.startDateValue;
        }
        return startDateValue;
    }
    /**
 * 获取某个月的总天数
 * 
 */
    static getDaysOfMonth(year, month) {
        var date = new Date(year, month, 0);
        var days = date.getDate();
        return days;
    }
    //获取查询的结束时间
    static getSearchEndTime(res, hms) {
        var endDateValue = "";
        var suffix = hms ? " 00:00:00" : "";
        if (!res.endDateValue) {
            endDateValue = "";
        } else if (res.endDateValue.length == 4) {
            var month = new Date().getMonth() + 1;
            var monthStr = month < 10 ? "-0" + month : "-" + month;
            endDateValue = res.endDateValue + monthStr + "-01" + suffix;
        } else if (res.endDateValue.length < 8) {
            //月
            endDateValue = res.endDateValue + "-01" + suffix;
            // let val = res.endDateValue + "-01"+suffix;
            // endDateValue=GlobalUtil.getDateOfMonthLastDay(val,suffix);
        } else if (res.endDateValue.length < 12) {
            endDateValue = res.endDateValue + suffix;
        } else {
            endDateValue = res.endDateValue;
        }
        return endDateValue;
    }
    /**
     * 根据时间粒度类型初始化时间值(month:n个月前）
     * @param json
     * @param hms 后缀：时分秒
     * @param month ：当粒度为月份时，取近month个月的数据
     */
    static initSearchDateValue(json, hms, month) {
        var suffix = hms ? " 00:00:00" : "";
        //根据时间粒度类型初始化时间值
        if (json.dateTypeId === 1 || json.dateTypeId === 7) {
            //时
            json.startDateValue = GlobalUtil.getPreDate(3) + " 00:00:00";
            json.endDateValue = GlobalUtil.getPreDate(1) + " 23:59:59";
            json.dateOptions.format = "yyyy-MM-dd HH";
        } else if (json.dateTypeId === 2) {
            //日  yyyy-mm-dd
            json.startDateValue = GlobalUtil.getBerforeWeekDate() + ' 00:00:00';
            //yyyy-mm-dd 23:59:59
            json.endDateValue = GlobalUtil.getPreDate(1) + ' 23:59:59';
            json.dateOptions.format = "yyyy-MM-dd";
        } else if (json.dateTypeId === 4) {
            //月
            json.dateOptions.format = "yyyy-MM";
            json.startDateValue = month
                ? GlobalUtil.getPreMonthArrays(month, 0)[month - 1] +
                "-01" +
                ' 00:00:00'
                : GlobalUtil.getCurrentYearAndFirstMonth() + "-01" + ' 00:00:00';
            json.endDateValue = GlobalUtil.getStandartDay("-") + ' 23:59:59';
            if (json.valueFormat) {
                json.valueFormat = "yyyy-MM";
            }
        } else if (json.dateTypeId == 5) {
            //年
            //yyyy-mm-dd 23:59:59
            //json.startDateValue = '2008-01-01' + "  00:00:00";
            json.startDateValue =
                new Date().getFullYear() - 3 + "-" + "01" + "-" + "01" + ' 00:00:00';
            json.endDateValue = GlobalUtil.getStandartDay("-") + ' 23:59:59';
            json.dateOptions.format = "yyyy";
        } else if (json.dateTypeId == 3) {
            json.dateOptions.format = "yyyy 第 WW 周"
            json.startDateValue = GlobalUtil.getPreDate(14) + ' 00:00:00';
            json.endDateValue = GlobalUtil.getStandartDay("-") + ' 23:59:59';
        } else {
            return
        }
        if (json.dateOptions.startDateValue) {
            json.dateOptions.startDateValue = json.startDateValue;
        }
        if (json.dateOptions.endDateValue) {
            json.dateOptions.endDateValue = json.endDateValue;
        }
    }
    /**
   *自定义根据时间粒度类型初始化时间值(month:n个月前）
   * @param json
   * @param hms 后缀：时分秒
   * @param month ：当粒度为月份时，取近month个月的数据
   */
    static newInitSearchDateValueSelf(json, hms, month) {
        var suffix = hms ? " 00:00:00" : "";
        //根据时间粒度类型初始化时间值
        if (json.dateTypeId === 1 || json.dateTypeId === 7) {
            //时
            json.startDateValue = GlobalUtil.getPreDate(10) + " 00:00:00";
            json.endDateValue = GlobalUtil.getImmobilizationDay(new Date().getTime() - 60 * 60 * 1000 * 24, '-') + " 23:59:59";
            json.dateOptions.format = "yyyy-MM-dd HH";
        } else if (json.dateTypeId === 2) {
            //日  yyyy-mm-dd
            json.startDateValue = GlobalUtil.getPreDate(31 + 1) + ' 00:00:00';
            //yyyy-mm-dd 23:59:59
            json.endDateValue = GlobalUtil.getPreDate(1) + ' 23:59:59';
            json.dateOptions.format = "yyyy-MM-dd";
        } else if (json.dateTypeId === 4) {
            //月
            json.dateOptions.format = "yyyy-MM";
            json.startDateValue = new Date().getFullYear() - 1 + "-" + (new Date().getMonth() + 1 >= 10 ? (new Date().getMonth() + 1) : '0' + (new Date().getMonth() + 1)) + '-01 00:00:00';
            json.endDateValue = GlobalUtil.newForMatToDateOfMonthLastDay(new Date().getFullYear() + '-' + new Date().getMonth() + '-05')
            if (json.valueFormat) {
                json.valueFormat = "yyyy-MM";
            }
        } else if (json.dateTypeId == 5) {
            //年
            //yyyy-mm-dd 23:59:59
            //json.startDateValue = '2008-01-01' + "  00:00:00";
            json.startDateValue = new Date().getFullYear() - 10 + "-" + "01" + "-" + "01" + ' 00:00:00';
            json.endDateValue = GlobalUtil.newForMatToDateOfMonthLastDay(new Date().getFullYear() - 1 + '-12-02')
            json.dateOptions.format = "yyyy";
        } else if (json.dateTypeId == 3) {
            json.dateOptions.format = "yyyy 第 WW 周"
            json.startDateValue = GlobalUtil.getPreDate(14) + ' 00:00:00';
            json.endDateValue = GlobalUtil.getStandartDay("-") + ' 23:59:59';
        } else {
            json.startDateValue = GlobalUtil.getPreDate(3) + " 00:00:00";
            json.endDateValue = GlobalUtil.newGetTodayCurEndDate();
            json.dateOptions.format = "yyyy-MM-dd HH";
        }
        if (json.dateOptions.startDateValue) {
            json.dateOptions.startDateValue = json.startDateValue;
        }
        if (json.dateOptions.endDateValue) {
            json.dateOptions.endDateValue = json.endDateValue;
        }
    }
    /**
 *自定义根据时间粒度类型初始化时间值(month:n个月前）
 * @param json
 * @param hms 后缀：时分秒
 * @param month ：当粒度为月份时，取近month个月的数据
 */
    static initSearchDateValueSelf(json, hms, month) {
        var suffix = hms ? " 00:00:00" : "";
        //根据时间粒度类型初始化时间值
        if (json.dateTypeId === 1 || json.dateTypeId === 7) {
            //时
            json.startDateValue = GlobalUtil.getPreDate(7) + " 00:00:00";
            json.endDateValue = GlobalUtil.getPreDate(1) + " 23:59:59";
            json.dateOptions.format = "yyyy-MM-dd HH";
        } else if (json.dateTypeId === 2) {
            //日  yyyy-mm-dd
            json.startDateValue = GlobalUtil.getPreDate(90) + ' 00:00:00';
            //yyyy-mm-dd 23:59:59
            json.endDateValue = GlobalUtil.getPreDate(1) + ' 23:59:59';
            json.dateOptions.format = "yyyy-MM-dd";
        } else if (json.dateTypeId === 4) {
            //月
            json.dateOptions.format = "yyyy-MM";
            json.startDateValue = month
                ? GlobalUtil.getPreMonthArrays(month, 0)[month - 1] +
                "-01" +
                ' 00:00:00'
                : GlobalUtil.getCurrentYearAndFirstMonth() + "-01" + ' 00:00:00';
            json.endDateValue = GlobalUtil.getStandartDay("-") + ' 23:59:59';
            if (json.valueFormat) {
                json.valueFormat = "yyyy-MM";
            }
        } else if (json.dateTypeId == 5) {
            //年
            //yyyy-mm-dd 23:59:59
            //json.startDateValue = '2008-01-01' + "  00:00:00";
            json.startDateValue =
                new Date().getFullYear() - 4 + "-" + "01" + "-" + "01" + ' 00:00:00';
            json.endDateValue = GlobalUtil.getStandartDay("-") + ' 23:59:59';
            json.dateOptions.format = "yyyy";
        } else if (json.dateTypeId == 3) {
            json.dateOptions.format = "yyyy 第 WW 周"
            json.startDateValue = GlobalUtil.getPreDate(14) + ' 00:00:00';
            json.endDateValue = GlobalUtil.getStandartDay("-") + ' 23:59:59';
        } else {
            json.startDateValue = GlobalUtil.getPreDate(3) + " 00:00:00";
            json.endDateValue = GlobalUtil.getPreDate(1) + " 23:59:59";
            json.dateOptions.format = "yyyy-MM-dd HH";
        }
        if (json.dateOptions.startDateValue) {
            json.dateOptions.startDateValue = json.startDateValue;
        }
        if (json.dateOptions.endDateValue) {
            json.dateOptions.endDateValue = json.endDateValue;
        }
    }
    //根据时间粒度类型初始化时间值二
    static initSearchDateValueMini(json) {
        if (json.dateTypeId === 2) {
            //日  yyyy-mm-dd
            json.startDateValue = GlobalUtil.getBerforeWeekDate() + " 00:00:00";
            //yyyy-mm-dd 23:59:59
            json.endDateValue = GlobalUtil.getTodayEndDate();
        } else {
            //yyyy-mm-dd 23:59:59
            json.startDateValue = GlobalUtil.getBerforeWeekDate() + " 00:00:00";
            json.endDateValue = GlobalUtil.getTodayEndDate();
        }
        if (json.dateOptions.startDateValue) {
            json.dateOptions.startDateValue = json.startDateValue;
        }
        if (json.dateOptions.endDateValue) {
            json.dateOptions.endDateValue = json.endDateValue;
        }
    }
    //根据时间粒度类型初始化时间值2
    static initSearchDateValueDown(json, hms, month) {
        // console.log(json,hms,month,7777)
        //根据时间粒度类型初始化时间值
        var suffix = hms ? " 00:00:00" : "";
        //根据时间粒度类型初始化时间值
        if (json.dateTypeIdDown === 1 || json.dateTypeIdDown === 7) {
            //时
            json.startDateValueDown = GlobalUtil.getPreDate(3) + " 00:00:00";
            json.endDateValueDown = GlobalUtil.getPreDate(1) + " 23:59:59";
            json.dateOptionsDown.format = "yyyy-MM-dd HH";
        } else if (json.dateTypeIdDown === 2) {
            //日  yyyy-mm-dd
            json.startDateValueDown = GlobalUtil.getBerforeWeekDate() + ' 00:00:00';
            //yyyy-mm-dd 23:59:59
            json.endDateValueDown = GlobalUtil.getPreDate(1) + ' 23:59:59';
            json.dateOptionsDown.format = "yyyy-MM-dd";
        } else if (json.dateTypeIdDown === 4) {
            //月
            json.dateOptionsDown.format = "yyyy-MM";
            json.startDateValueDown = month
                ? GlobalUtil.getPreMonthArrays(month, 0)[month - 1] +
                "-01" +
                ' 00:00:00'
                : GlobalUtil.getCurrentYearAndFirstMonth() + "-01" + ' 00:00:00';
            json.endDateValueDown = GlobalUtil.getStandartDay("-") + ' 23:59:59';
            if (json.valueFormat) {
                json.valueFormat = "yyyy-MM";
            }
        } else if (json.dateTypeIdDown == 5) {
            //年
            //yyyy-mm-dd 23:59:59
            //json.startDateValueDown = '2008-01-01' + "  00:00:00";
            json.startDateValueDown =
                new Date().getFullYear() - 3 + "-" + "01" + "-" + "01" + ' 00:00:00';
            json.endDateValueDown = GlobalUtil.getStandartDay("-") + ' 23:59:59';
            json.dateOptionsDown.format = "yyyy";
        } else if (json.dateTypeIdDown == 3) {
            json.dateOptionsDown.format = "yyyy 第 WW 周"
            json.startDateValueDown = GlobalUtil.getPreDate(14) + ' 00:00:00';
            json.endDateValueDown = GlobalUtil.getStandartDay("-") + ' 23:59:59';
        } else {
            return
        }
        if (json.dateOptionsDown.startDateValueDown) {
            json.dateOptionsDown.startDateValueDown = json.startDateValueDown;
        }
        if (json.dateOptionsDown.endDateValue) {
            json.dateOptionsDown.endDateValue = json.endDateValueDown;
        }
    }
    /*---------------------------------end----------------------------------*/
    //获取两日期之间日期列表函数
    static getdiffdate(stime, etime) {
        //初始化日期列表，数组
        var diffdate = new Array();
        var i = 0;
        //开始日期小于等于结束日期,并循环
        while (stime <= etime) {
            diffdate[i] = stime;

            //获取开始日期时间戳
            var stime_ts = new Date(stime).getTime();
            console.log("当前日期：" + stime + "当前时间戳：" + stime_ts);

            //增加一天时间戳后的日期
            var next_date = stime_ts + 24 * 60 * 60 * 1000;

            //拼接年月日，这里的月份会返回（0-11），所以要+1
            var next_dates_y = new Date(next_date).getFullYear() + "-";
            var next_dates_m =
                new Date(next_date).getMonth() + 1 < 10
                    ? "0" + (new Date(next_date).getMonth() + 1) + "-"
                    : new Date(next_date).getMonth() + 1 + "-";
            var next_dates_d =
                new Date(next_date).getDate() < 10
                    ? "0" + new Date(next_date).getDate()
                    : new Date(next_date).getDate();

            stime = next_dates_y + next_dates_m + next_dates_d;

            //增加数组key
            i++;
        }
        console.log(diffdate);
        return diffdate;
    }

    /**
     * 获取前一天的日期  yyyy-mm-dd
     * @returns {string}
     */
    static getPreviousDay() {
        var preDate = new Date(new Date().getTime() - 24 * 60 * 60 * 1000);
        return GlobalUtil.formatToYMD(preDate);
    }

    /**
     * 获取前一天的时间  yyyy-mm-dd hh:mm:ss
     * @returns {string}
     */
    static getPreviousDateTime() {
        let times = new Date().getTime();
        return (
            new Date(times - 86400 * 1000)
                .toLocaleDateString()
                .replace(/\//g, "-") +
            " " +
            new Date(times - 86400 * 1000).toTimeString().split("G")[0]
        );
    }
    /**
     * 获取特定时间的  yyyy-mm-dd hh:mm:ss
     * @returns {string}
     */
    static getspecialTime(val) {
        return (
            new Date(val).toLocaleDateString().replace(/\//g, "-") +
            " " +
            new Date(val).toTimeString().substring(0, 5)
        );
    }

    /**
     * 获取当前日期  yyyy-mm-dd
     * @returns {string}
     */
    static getCurrentDay() {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    }

    /**
     * 获取给定时间年月日  yyyy-mm-dd
     * @returns {string}
     */
    static getImmobilizationDay(dateTime, seperator1) {
        var date = new Date(dateTime);
        var seperator1 = "-";
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    }

    /**
     * 获取当前日期  yyyy,mm,dd
     * @returns {string}
     */
    static getStandartDay(seperator1) {
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        var currentdate = year + seperator1 + month + seperator1 + strDate;
        return currentdate;
    }

    /**
     * 获取当前日期前七天  yyyy,mm,dd
     * @returns {string}
     */
    static getBeforeStandartDay(seperator1) {
        let date = new Date(new Date().getTime() - 86400 * 1000 * 6);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        return year + seperator1 + month + seperator1 + strDate;
    }

    /**
     * 获取制定日期  yyyy-mm-dd
     * @returns {string}
     */
    static getDay(date) {
        return date.toLocaleDateString().replace(/\//g, "-");
    }

    /**
     * 获取制定日期  yyyy-mm
     * @returns {string}
     */
    static getMonth(date) {
        return date.getFullYear() + "-" + GlobalUtil.pad2(date.getMonth());
    }
    /**
     * 获取当前时间点  HH:mm
     * @returns {string}
     */
    static getCurrentDate(data) {
        let Hour = new Date(data).getHours();
        console.log(Hour > 10, "Hour", typeof Hour);
        Hour = Hour >= 10 ? Hour : "0" + Hour;
        let minute = new Date(data).getMinutes();
        minute = minute >= 10 ? minute : "0" + minute;
        return Hour + ":" + minute;
    }

    static pad2(n) {
        return n < 10 ? "0" + n : n;
    }

    /**
     * 获取当前时间点 yyyy-mm-dd HH
     * @returns {string}
     */
    static getCurrentDateHour() {
        return (
            GlobalUtil.getCurrentDay() +
            " " +
            GlobalUtil.pad2(new Date().getHours())
        );
    }

    /**
     * 获取当前时间点  yyyy-mm-dd HH:mm
     * @returns {string}
     */
    static getCurrentDateHourMinute() {
        return (
            GlobalUtil.getCurrentDay() +
            " " +
            GlobalUtil.pad2(new Date().getHours()) +
            ":" +
            GlobalUtil.pad2(new Date().getMinutes()) +
            ":59"
        );
    }

    /**
     * 获取指定日期N天之后的日期：yyyy-mm-dd
     * @param dd
     * @param AddDayCount
     * @returns {string}
     * @constructor
     */
    static GetAfterDateStr(dd, AddDayCount) {
        dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
        var y = dd.getFullYear();
        var m =
            dd.getMonth() + 1 < 10
                ? "0" + (dd.getMonth() + 1)
                : dd.getMonth() + 1; //获取当前月份的日期，不足10补0
        var d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate(); //获取当前几号，不足10补0
        return y + "-" + m + "-" + d;
    }

    /**
     * 获取当前之前的7天
     */
    static getBerforeWeekDate() {
        let date = new Date(new Date().getTime() - 86400 * 1000 * 6);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours();
        hour = hour > 9 ? hour : "0" + hour;
        let minute = date.getMinutes();
        minute = minute > 9 ? minute : "0" + minute;
        let second = date.getSeconds();
        second = second > 9 ? second : "0" + second;
        return year + "-" + month + "-" + day;
    }
    /**
     * 获取当前之前的14天
     */
    static getBerforeTwoWeekDate() {
        let date = new Date(new Date().getTime() - 86400 * 1000 * 13);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours();
        hour = hour > 9 ? hour : "0" + hour;
        let minute = date.getMinutes();
        minute = minute > 9 ? minute : "0" + minute;
        let second = date.getSeconds();
        second = second > 9 ? second : "0" + second;
        return year + "-" + month + "-" + day;
    }

    /**
     * 获取前N天的日期
     * @param days 时间间隔天数
     * @returns {string}
     */
    static getPreDate(days) {
        var now = new Date();
        var nowAfterDays = now.setDate(now.getDate() - days);
        nowAfterDays = new Date(nowAfterDays);
        var end =
            nowAfterDays.getFullYear() +
            "-" +
            GlobalUtil.pad2(nowAfterDays.getMonth() + 1) +
            "-" +
            GlobalUtil.pad2(nowAfterDays.getDate());
        return end;
    }

    /**
     * 获取前N年第N个月的日期(yyyy-MM)数组
     */
    static getPreMonthArrays(n, i) {
        //创建现在的时间
        var data = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * i);
        //获取年
        var year = data.getFullYear();
        //获取月
        var mon = data.getMonth() + 1;
        var arry = new Array();
        for (var i = 0; i < n; i++) {
            mon = mon - 1;
            if (mon <= 0) {
                year = year - 1;
                mon = mon + 12;
            }
            if (mon < 10) {
                mon = "0" + mon;
            }

            arry[i] = year + "-" + mon;
        }

        return arry;
    }
    //获取年01月
    static getCurrentYearAndFirstMonth() {
        var now = new Date();
        return now.getFullYear() + "-" + GlobalUtil.pad2(now.getMonth() + 1);
    }

    //获取年12月
    static getCurrentYearAndLastMonth() {
        return new Date().getFullYear() + "-12";
    }

    /**
     * 获取今天的日期 -结束时间使用，拼接 yyyy-mm-dd 23：59：59
     * todo 用于界面日期时间选择规则-结束时间
     */
    static getTodayEndDate() {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours();
        hour = hour > 9 ? hour : "0" + hour;
        let minute = date.getMinutes();
        minute = minute > 9 ? minute : "0" + minute;
        let second = date.getSeconds();
        second = second > 9 ? second : "0" + second;
        return year + "-" + month + "-" + day + " 23:59:59";
    }
    /**
     * 获取今天的日期 -前一个小时的59分59秒，拼接 yyyy-mm-dd hh:mm:ss
     * todo 用于界面日期时间选择规则-结束时间
     */
    static newGetTodayCurEndDate() {
        let date = new Date(new Date().getTime() - 1000 * 60 * 60);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours();
        hour = hour > 9 ? hour : "0" + hour;
        return year + "-" + month + "-" + day + ` ${hour}:59:59`;
    }
    /**
     * 获取今天的日期 -结束时间使用，拼接 yyyy-mm-dd hh:mm:ss
     * todo 用于界面日期时间选择规则-结束时间
     */
    static getTodayCurEndDate() {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours() - 2;
        hour = hour > 9 ? hour : "0" + hour;
        let minute = date.getMinutes();
        minute = minute > 9 ? minute : "0" + minute;
        let second = date.getSeconds();
        second = second > 9 ? second : "0" + second;
        return year + "-" + month + "-" + day + ` ${hour}:${minute}:${second}`;
    }
    /**
     * 获取几天前 -结束时间使用，拼接 yyyy-mm-dd hh:mm:ss
     * todo 用于界面日期时间选择规则-结束时间
     */
    static getTodayCurBeforeEndDate(i) {
        let date = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * i);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours() - 2;
        hour = hour > 9 ? hour : "0" + hour;
        let minute = date.getMinutes();
        minute = minute > 9 ? minute : "0" + minute;
        let second = date.getSeconds();
        second = second > 9 ? second : "0" + second;
        return year + "-" + month + "-" + day + ` ${hour}:${minute}:${second}`;
    }
    /**
     * 获取几天前 -结束时间使用，拼接 yyyy-mm-dd 23：59：59
     * todo 用于界面日期时间选择规则-结束时间
     */
    static getTodayBeforeEndDate(i) {
        let date = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * i);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours();
        hour = hour > 9 ? hour : "0" + hour;
        let minute = date.getMinutes();
        minute = minute > 9 ? minute : "0" + minute;
        let second = date.getSeconds();
        second = second > 9 ? second : "0" + second;
        return year + "-" + month + "-" + day + " 23:59:59";
    }

    static getTodayStartDate() {
        // let date = new Date(new Date().getTime()-1000 * 60 * 60 * 24 * 7);
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours();
        hour = hour > 9 ? hour : "0" + hour;
        let minute = date.getMinutes();
        minute = minute > 9 ? minute : "0" + minute;
        let second = date.getSeconds();
        second = second > 9 ? second : "0" + second;
        return year + "-" + month + "-" + day + " 00:00:00";
    }
    // 获取上一周
    static getTodaYStartDate() {
        let date = new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 7);
        // let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours();
        hour = hour > 9 ? hour : "0" + hour;
        let minute = date.getMinutes();
        minute = minute > 9 ? minute : "0" + minute;
        let second = date.getSeconds();
        second = second > 9 ? second : "0" + second;
        return year + "-" + month + "-" + day + " 00:00:00";
    }
    // 获取前两年的时间
    static getTodaysStartDate() {
        let date = new Date();
        let year = date.getFullYear() - 2;
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours();
        hour = hour > 9 ? hour : "0" + hour;
        let minute = date.getMinutes();
        minute = minute > 9 ? minute : "0" + minute;
        let second = date.getSeconds();
        second = second > 9 ? second : "0" + second;
        return year + "-" + month + "-" + day + " 00:00:00";
    }

    /**
     * 获取当前时间  yyyy-mm-dd hh:mm:ss
     * @returns {string}
     */
    static getCurrentDateTime() {
        let date = new Date();
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours();
        hour = hour > 9 ? hour : "0" + hour;
        let minute = date.getMinutes();
        minute = minute > 9 ? minute : "0" + minute;
        let second = date.getSeconds();
        second = second > 9 ? second : "0" + second;
        return (
            year +
            "-" +
            month +
            "-" +
            day +
            " " +
            hour +
            ":" +
            minute +
            ":" +
            second
        );
    }

    /**
     * 获取当前月份
     * @returns {number}
     */
    static getCurrentMonth() {
        return new Date().getMonth() + 1;
    }

    /**
     * 获取当前年yyyy
     */
    static getCurrentYear() {
        let date = new Date();
        return date.getFullYear();
    }

    /**
     * 获取当前年月
     * @returns {string}  yyyy-mm
     */
    static getCurrentYearAndMonth() {
        let date = new Date();
        return date.getFullYear() + "-" + GlobalUtil.pad2(date.getMonth() + 1);
    }

    /**
     * 获取当前年月
     * @returns {string}  yyyy年mm月
     */
    static getCurrentYearAndMonthNew() {
        let date = new Date();
        return (
            date.getFullYear() +
            "年" +
            GlobalUtil.pad2(date.getMonth() + 1) +
            "月"
        );
    }

    /**
     * 深拷贝
     * @param obj
     * @returns {any}
     */
    static deepCopy(obj) {
        return JSON.parse(JSON.stringify(obj));
    }

    /**
     * 时间转换成 年
     * @param dateString  日期对象格式/日期字符串（详细见Date对象）
     * @returns {string}
     */
    static formatToYear(dateString) {
        let date = new Date(dateString);
        return date.getFullYear();
    }

    /**
     * 时间转换成 年-月
     * @param dateString  日期对象格式/日期字符串（详细见Date对象）
     * @returns {string}
     */
    static formatToYearAndMonth(dateString) {
        let date = new Date(dateString);
        return date.getFullYear() + "-" + GlobalUtil.pad2(date.getMonth() + 1);
    }

    /**
     * 时间转换成 年-月-日
     * @param dateString 日期对象格式/日期字符串（详细见Date对象）
     * @returns {string}
     */
    static formatToDate(dateString) {
        return new Date(dateString).toLocaleDateString().replace(/\//g, "-");
    }

    /**
     * 获取两个时间范围所有天数
     * @param begin
     * @param end
     */
    static getTimeRangeByDay(begin, end) {
        let timeArray = [];
        let ab = begin.split("-");
        let ae = end.split("-");
        let db = new Date();
        db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
        let de = new Date();
        de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
        let unixDb = db.getTime();
        let unixDe = de.getTime();
        for (let k = unixDb; k <= unixDe;) {
            timeArray.push(this.formatToYMD(new Date(parseInt(k))));
            k = k + 24 * 60 * 60 * 1000;
        }
        return timeArray;
    }

    /**
     * 时间转换成 年-月-日
     * @param dateString 日期对象格式/日期字符串（详细见Date对象）
     * @returns {string}
     */
    static formatToDates(dateString) {
        let date = new Date(dateString);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours();
        hour = hour > 9 ? hour : "0" + hour;
        let minute = date.getMinutes();
        minute = minute > 9 ? minute : "0" + minute;
        let second = date.getSeconds();
        second = second < 10 ? "0" + second : second;
        return year + "-" + month + "-" + day;
    }

    /**
     * 时间转换成 标准时间
     * @param dateString 日期对象格式/日期字符串（详细见Date对象）
     * @returns {string}
     */
    static formatToStardartDate(dateString) {
        let data = new Date(dateString);
        let year = data.getFullYear();
        let month = data.getMonth();
        let date = data.getDate();
        return new Date(year, month, date);
    }

    static formatToDating(dateString) {
        let date = new Date(dateString);
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        month = month > 9 ? month : "0" + month;
        let day = date.getDate();
        day = day > 9 ? day : "0" + day;
        let hour = date.getHours();
        hour = hour > 9 ? hour : "0" + hour;
        let minute = date.getMinutes();
        minute = minute > 9 ? minute : "0" + minute;
        let second = date.getSeconds();
        second = second > 9 ? second : "0" + second;
        return year + "/" + month + "/" + day;
    }

    static formatToYMD(date) {
        let year = date.getFullYear(); //获取完整的年份(4位,1970-????)
        let month = date.getMonth() + 1; //获取当前月份(0-11,0代表1月)
        let day = date.getDate(); //获取当前日(1-31)
        if (month < 10) {
            month = "0" + month;
        }
        if (day < 10) {
            day = "0" + day;
        }
        return year + "-" + month + "-" + day;
    }

    /**
     * 时间转换成 年-月-日 23:59:59
     * @param dateString
     * @returns {string}
     */
    static formatToEndDate(dateString) {
        return (
            new Date(dateString).toLocaleDateString().replace(/\//g, "-") +
            " 23:59:59"
        );
    }

    /**
     * 时间转换成 年-月-日 00:00:00
     * @param dateString
     * @returns {string}
     */
    static formatToStartDate(dateString) {
        return (
            new Date(dateString).toLocaleDateString().replace(/\//g, "-") +
            " 00:00:00"
        );
    }

    //获取当月第一天  yyyy-mm-dd 00:00:00
    static forMatToDateOfMonthFirstDay(dateString) {
        let date = new Date(dateString);
        let month = date.getMonth() + 1
        if (month < 10) {
            month = "0" + month;
        }
        return (
            date.getFullYear() +
            "-" +
            month +
            "-01" +
            " 00:00:00"
        );
    }

    //获取当月最后一天 yyyy-mm-dd 23:59:59
    static forMatToDateOfMonthLastDay(dateString) {
        let date = new Date(dateString);
        //下一个月的第一天 -- 一天  =  当前月最后一天
        let year = date.getFullYear(),
            month = date.getMonth() + 1;
        let lastDay;
        if (month + 1 > 12) {
            // 跨年
            lastDay = new Date(
                new Date(year + 1 + "-" + 1).getTime() - 86400 * 1000
            ).getDate();
        } else {
            lastDay = new Date(
                new Date(year + "-" + month).getTime() - 86400 * 1000
            ).getDate();
        }
        return year + "-" + month + "-" + lastDay + " 23:59:59";
    }
    //获取当月最后一天 yyyy-mm-dd 23:59:59
    static newForMatToDateOfMonthLastDay(dateString) {
        let date = new Date(dateString);
        //下一个月的第一天 -- 一天  =  当前月最后一天
        let year = date.getFullYear(),
            month = date.getMonth() + 1;
        let lastDay;
        if (month + 1 > 12) {
            // 跨年
            lastDay = new Date(
                new Date(year + 1 + "-" + 1).getTime() - 86400 * 1000
            ).getDate();
        } else {
            lastDay = new Date(
                new Date(year + "-" + (month + 1)).getTime() - 86400 * 1000
            ).getDate();
        }
        month = month < 10 ? '0' + month : month
        return year + "-" + month + "-" + lastDay + " 23:59:59";
    }
    //获取当月最后一天 yyyy-mm-dd ext
    static getDateOfMonthLastDay(dateString, suffix) {
        var endDate = new Date(dateString);
        var month = endDate.getMonth();
        var nextMonth = ++month;
        var nextMonthFirstDay = new Date(endDate.getFullYear(), nextMonth, 1);
        var oneDay = 1000 * 60 * 60 * 24;
        let date = new Date(nextMonthFirstDay - oneDay);
        return GlobalUtil.formatToYMD(date) + suffix;
    }
    //获取当月最后一天 yyyy-mm-dd 23:59:59
    static forMatToDateOfMonthLastDayy(dateString) {
        let date = new Date(dateString);
        //下一个月的第一天 -- 一天  =  当前月最后一天
        let year = date.getFullYear(),
            month = date.getMonth() + 1;
        let days = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
        if (month < 10) {
            month = "0" + month;
        }
        return year + "-" + month + "-" + days[month - 1] + " 23:59:59";
    }

    //删除空字段
    static deleteEmptyKey(obj) {
        if (!(obj instanceof Object)) return;
        for (let key in obj) {
            if (obj[key] === null || obj[key] === "") {
                delete obj[key];
            }
            this.deleteEmptyKey(obj[key]);
        }
    }

    //获取dom元素相对文档流的当前X、Y轴位置
    static getElPositionWithBody(el) { }

    /** 启用 禁用  value <==> label  互转换
     * Status = [
     {
            label: "启用",
            value: 0
        },
     {
            label: "禁用",
            value: 1,
            default: true
        }
     ]
     * @param res
     * @returns {*}
     */
    static filterStatus(res) {
        for (let i = 0, len = this.status.length; i < len; i++) {
            if (typeof res === "number" && res === this.status[i].value) {
                return this.status[i].label;
            } else if (
                typeof res === "string" &&
                res === this.status[i].label
            ) {
                return this.status[i].value;
            }
        }
        return res;
    }
    /**
     * 获取上一个月
     *
     * @date 格式为yyyy-mm的日期，如：2014-01
     */
    static getPreYearMonth() {
        var d = new Date();
        var year = d.getFullYear(); //获取当前日期的年份
        var month = d.getMonth() + 1; //获取当前日期的月份

        var year2 = year;
        var month2 = parseInt(month) - 1;
        if (month2 == 0) {
            year2 = parseInt(year2) - 1;
            month2 = 12;
        }
        if (month2 < 10) {
            month2 = "0" + month2;
        }
        var t2 = year2 + "-" + month2;
        return t2;
    }

    // Status = [
    //     {
    //            label: "启用",
    //            value: 0
    //        },
    //     {
    //            label: "禁用",
    //            value: 1,
    //            default: true
    //        }
    //     ]
    /** 水，电，气  energytype <==> text  互转换
     * energytype = [
     {
        label: "水",
        value: 0
    },
     {
        label: "电",
        value: 1,
    }，
     {
        label: "气",
        value: 2,
    }
     ]
     * @param res
     * @returns {*}
     */
    static filterEnergyType(res) {
        for (let i = 0, len = this.energyType.length; i < len; i++) {
            if (typeof res === "number" && res === this.energyType[i].value) {
                return this.energyType[i].label;
            } else if (
                typeof res === "string" &&
                res === this.energyType[i].label
            ) {
                return this.energyType[i].value;
            }
        }
        return res;
    }

    /**
     * 任职状态  value => label
     * @param val
     * @returns {*}
     */
    static filterJobStatus(valueList, key) {
        for (let i = 0, len = valueList.length; i < len; i++) {
            valueList[i][key] = WorkState[valueList[i][key]]
                ? WorkState[valueList[i][key]].label
                : valueList[i][key];
        }
        return valueList;
    }

    /**
     * 字段扩展
     * @param dataArr   目标数组
     * @param field: {  字段映射
     *     old: new     旧字段： 新字段
     * }
     *
     * @param isInherit 是否继承， true继承扩展字段；false 生成新数组（只包含目标映射字段）返回
     */
    static fieldExtend(dataArr, field, isInherit) {
        let newDataArr = [];
        for (let i = 0, len = dataArr.length; i < len; i++) {
            let obj = {};
            for (let key in field) {
                if (dataArr[i][key] === undefined) continue;
                if (isInherit) {
                    dataArr[i][field[key]] = dataArr[i][key];
                } else {
                    obj[field[key]] = dataArr[i][key];
                }
            }
            newDataArr.push(obj);
        }
        return this.deepCopy(isInherit ? dataArr : newDataArr);
    }

    /**
     * 数字字符串转成数字数组  '1,2,3,4' ==> [1,2,3,4]
     * @param stringNum
     * return []
     */
    static stringNumToArrNum(stringNum) {
        if (typeof stringNum !== "string") return [];
        if (stringNum.length === 0) return [];
        let strArr = stringNum.split(",");

        for (let i = 0, len = strArr.length; i < len; i++) {
            if (/^[0-9]*$/.test(strArr[i])) {
                strArr[i] = Number(strArr[i]);
            }
        }
        return strArr;
    }

    //过滤 0 ==> null   //接口 空值 返回0 导致下拉框页面默认显示 为0
    static filterZero(data) {
        return data === 0 ? null : data;
    }

    static arrayConvertSelectData(arr, keyArr) {
        if (!(arr instanceof Array)) return arr;
        if (!(keyArr instanceof Array)) return arr;
        let objArr = [];
        for (let i = 0, len = arr.length; i < len; i++) {
            for (let k = 0, kLen = keyArr.length; k < kLen; k++) {
                let obj = {};
                obj[keyArr[k]] = arr[i];
                objArr.push(obj);
            }
        }
        return objArr;
    }

    /**类型 (1, "环境"), (2, "风柜"), (3, "风盘"), (4, "照明");
     * 监控界面类型转换，传数字转换为文字，反之亦然
     * @Author chendl
     * @Create 2018/10/24
     */
    static filterMonitorInterfaceType(res) {
        for (let i = 0, len = this.monitorInterfaceType.length; i < len; i++) {
            if (
                typeof res === "number" &&
                res === this.monitorInterfaceType[i].value
            ) {
                return this.monitorInterfaceType[i].label;
            } else if (
                typeof res === "string" &&
                res === this.monitorInterfaceType[i].label
            ) {
                return this.monitorInterfaceType[i].value;
            }
        }
    }

    /**
     * param 将要转为URL参数字符串的对象
     * key URL参数字符串的前缀
     * encode true/false 是否进行URL编码,默认为true
     *
     * return URL参数字符串
     */
    static urlEncode(param, key, encode) {
        if (param == null) return "";
        var paramStr = "";
        var t = typeof param;
        if (t == "string" || t == "number" || t == "boolean") {
            paramStr +=
                "&" +
                key +
                "=" +
                (encode == null || encode ? encodeURIComponent(param) : param);
        } else {
            for (var i in param) {
                var k =
                    key == null
                        ? i
                        : key +
                        (param instanceof Array ? "[" + i + "]" : "." + i);
                paramStr += this.urlEncode(param[i], k, encode);
            }
        }
        //console.log("paramStr==",paramStr)
        return paramStr;
    }

    //GMT时间转换成sting时间
    static gmtToString(time) {
        let date = new Date(time);
        let Str =
            date.getFullYear() +
            "-" +
            GlobalUtil.pad2(date.getMonth() + 1) +
            "-" +
            GlobalUtil.pad2(date.getDate()) +
            " " +
            GlobalUtil.pad2(date.getHours()) +
            ":" +
            GlobalUtil.pad2(date.getMinutes()) +
            ":" +
            GlobalUtil.pad2(date.getSeconds());
        return Str;
    }

    static tj(it, code) {
        it.$ba.trackPageview(`${it.$route.path.toLowerCase()}?tj=${code}`);
    }

    static array_contain(array, obj) {
        for (var i = 0; i < array.length; i++) {
            if (array[i] == obj)
                //如果要求数据类型也一致，这里可使用恒等号===
                return true;
        }
        return false;
    }

    //通过周，计算时间
    static dateFromWeek(year, week, day) {
        //   year       年
        //   week       周
        //   day         星期   (0-6,   0代表周日)
        var date1 = new Date(year, 0, 1);
        var dayMS = 24 * 60 * 60 * 1000;
        var firstDay = (7 - date1.getDay()) * dayMS;
        var weekMS = (week - 2) * 7 * dayMS;
        var result = date1.getTime() + firstDay + weekMS + day * dayMS;
        date1.setTime(result);
        return date1.toLocaleDateString();
    }

    //通过周，计算时间
    static dateFromSeason(season, type) {
        if (type == 0) {
            switch (season) {
                case "1":
                    return "01-01 00:00:00";
                case "2":
                    return "04-01 00:00:00";
                case "3":
                    return "07-01 00:00:00";
                case "4":
                    return "10-01 00:00:00";
            }
        } else if (type == 1) {
            switch (season) {
                case "1":
                    return "03-01 23:59:59";
                case "2":
                    return "06-01 23:59:59";
                case "3":
                    return "09-01 23:59:59";
                case "4":
                    return "12-01 23:59:59";
            }
        }
    }
    static numFormat(val) {
        // console.log('numFormat1 :>> ', val);
        if (val == "--") {
            return val;
        }
        if (!val || val == 0) {
            return 0;
        }
        let res = '';
        if (!isNaN(val)) {
            res = val < 100 ? val.toFixed(2) : val.toFixed();
            // console.log('numFormat :>> ', res);
        }
        return res;
    }
    //处理数字：过100，四舍五入保留整数，小于100，四舍五入保留2位小数
    static handleData(val) {
        if (val == "--") {
            return val;
        }
        if (!val || val == 0 || val == "0") {
            return 0;
        }
        let v = val.toString();
        if (v.indexOf("%") != -1) {
            v = v.replace("%", "");
        }
        let floatv = parseFloat(v);
        if (floatv >= 100 || (floatv < 0 && floatv <= -100)) {
            if (v.indexOf(".") != -1) {
                if (floatv < 0 && floatv <= -100) {
                    if (parseInt(v.split(".")[1].substring(0, 1)) >= 5) {
                        v = parseInt(v.split(".")[0]) - 1;
                    } else {
                        v = parseInt(v.split(".")[0]);
                    }
                } else {
                    if (parseInt(v.split(".")[1].substring(0, 1)) >= 5) {
                        v = parseInt(v.split(".")[0]) + 1;
                    } else {
                        v = parseInt(v.split(".")[0]);
                    }
                }
            }
        } else {
            if (v.indexOf(".") != -1) {
                if (v.split(".")[1].length > 2) {
                    let v3 = parseInt(v.split(".")[1].substring(2, 3));
                    // if(parseInt(v.split('.')[1].substring(0, 2))==99&&v.indexOf('-')==-1){
                    //     v = (parseInt(v.split('.')[0])+1)+'.00'
                    // }
                    // else
                    if (v3 >= 5) {
                        v =
                            v.split(".")[0] +
                            "." +
                            (parseInt(v.split(".")[1].substring(0, 2)) + 1);
                    } else {
                        v =
                            parseFloat(v.split(".")[0] + ".0") +
                            parseFloat("0." + v.split(".")[1].substring(0, 2));
                    }
                }
            }
        }
        if (val.toString().indexOf("%") != -1) {
            v = v + "%";
        }
        // console.log('HandleData->原数据:' + val+'，转换后：'+v);
        return v;
    }

    static removeRepeat(vals, symbol) {
        let rval = "";
        if (vals.indexOf(symbol) != -1) {
            let l = vals.split(symbol).length;
            for (let i = 0; i < l; i++) {
                if (rval.indexOf(vals.split(symbol)[i]) == -1) {
                    rval += vals.split(symbol)[i];
                } else {
                    l--;
                }

                if (i < l - 1) {
                    rval += ",";
                }
            }
            return rval;
        }
    }
    /**
     *
     * @param {*}
     * 过滤按钮
     */
    static filterMenu(menuList) {
        return menuList.filter(item => {
            // 过滤按钮
            return item.funType !== 1
        }).map(item => {
            item = Object.assign({}, item)
            if (item.children) {
                item.children = this.filterMenu(item.children)
            }
            return item
        })
    }
    /**
     *
     * @param {*}
     * 过滤页面
     */
    static filterMenuPage(menuList, name, path = []) {
        for (let i = 0; i < menuList.length; i++) {
            const item = menuList[i];
            if (item.name == name) {
                path = item.children
                return path
            }
            if (item.children) {
                const getTreeFun = this.filterMenuPage(item.children, name, path)
                if (getTreeFun.length) return getTreeFun
            }
            // path.pop()
        }
        return []
    }
    /**
     *
     * @param {*}
     * downUrl = "/api/admin/file/downloadFile"
     * 下载文件方法
     */
    static downloadFile(fileId, downUrl = "/api/admin/file/downloadFile") {
        var downLoadIframe = document.querySelector("#downLoadIframe");
        if (!downLoadIframe) {
            downLoadIframe = document.createElement("iframe");
            downLoadIframe.setAttribute("id", "downLoadIframe");
        }
        downLoadIframe.src = `${downUrl}?token=${store.getters.getRequestHeader
            }&filePath=${window.encodeURI(fileId)}`;
        downLoadIframe.style.display = "none";
        if (!document.querySelector("#downLoadIframe"))
            document.body.appendChild(downLoadIframe);
    }
    static downloadFileNoToken(url, title = "") {
        let { protocol, hostname, port } = window.document.location
        let href = `${protocol + hostname + port}/${url}`
        if (hostname == 'localhost') {
            href = 'http://192.168.1.40:227/' + url
        }
        const a = document.createElement('a');
        a.setAttribute('href', href);
        a.setAttribute('download', title);
        a.click();
    }
    // 上面是获取时间范围的处理，下面是对于时间组件时间的处理
    static initDateValue(json, time) {
        // console.log(json,999999)
        let suffix = ' 00:00:00'
        switch (json.timeType) {
            case 2://日
                json.startTime = dateTimeUtils.getYearMonthDayByDate(dateTimeUtils.getPreDate(1)) + suffix
                json.endTime = dateTimeUtils.getYearMonthDayByDate(dateTimeUtils.getPreDate(1)) + ' 23:59:59'
                break;
            case 4://月
                // console.log(time.getMonth(),111)
                json.startTime = dateTimeUtils.getYearMonthDayByDate(time) + suffix;
                json.endTime = dateTimeUtils.getYearMonthByDate(time) + '-' + dateTimeUtils.getday(String(time.getMonth() + 1)) + ' 23:59:59';
                break;

            default://暂时为年
                json.startTime = time.getFullYear() + "-01-01" + suffix;
                json.endTime = time.getFullYear() + "-12-31" + ' 23:59:59';
                break;
        }
    }
    static newInitDateValue(json, time) {
        console.log(json, 999999)
        let suffix = ' 00:00:00'
        switch (json.timeType) {
            case 2://日
                json.startTime = dateTimeUtils.getYearMonthDayByDate(time) + suffix
                json.endTime = dateTimeUtils.getYearMonthDayByDate(time) + ' 23:59:59'
                break;
            case 4://月
                // console.log(time.getMonth(),111)
                json.startTime = dateTimeUtils.getYearMonthByDate(time) + '-01' + suffix;
                json.endTime = dateTimeUtils.getDateMonthLastDayStr(time);
                break;

            default://暂时为年
                json.startTime = time.getFullYear() + "-01-01" + suffix;
                json.endTime = time.getFullYear() + "-12-31" + ' 23:59:59';
                break;
        }
    }
    static tranNumber(num, point) {
        if (isNaN(parseInt(num))) {
            return num
        }
        let numStr = parseInt(num).toString();
        // 个十百千万十万百万千万亿
        // 123456789
        if (numStr.length < 5) {
            return numStr;
        } else if (numStr.length > 8) {
            return (parseFloat(num / 100000000)).toFixed(point) + '亿';
        } else {
            return (parseFloat(num / 10000)).toFixed(point) + '万';
        }
    }
    // 文件下载
    static downLoadFile(excelData, fileName, suffix = '.xlsx') {
        let url = window.URL.createObjectURL(new Blob([excelData]));
        // let url = window.URL.createObjectURL(new Blob([excelData],{type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"}));
        let link = document.createElement('a'); // 例用a标签的download属性实现下载
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', fileName + suffix);
        document.body.appendChild(link);// 在页面中动态添加一个a标签
        link.click()
        document.body.removeChild(link); // 点击之后删除该dom节点
        setTimeout(function () {
            URL.revokeObjectURL(url);
        }, 100);
    }
}
